(() => {
  'use strict';

  const contextElement = document.getElementById('pagan-blog-analytics-context');
  if (!contextElement || contextElement.dataset.initialized) return;
  contextElement.dataset.initialized = 'true';

  let context;
  try {
    context = JSON.parse(contextElement.textContent);
  } catch (_) {
    return;
  }

  const topicSource = `${context.articleHandle} ${context.blogHandle} ${context.articleTitle}`.toLowerCase();
  const topicRules = [
    ['hecate', /hecate|hekate|strophalos|wheel-of-hecate/],
    ['ishtar_inanna', /ishtar|inanna/],
    ['runes_norse', /rune|runic|elder.futhark|norse|viking|odin|thor|freya|freyja/],
    ['wheel_festivals', /wheel.of.the.year|sabbat|yule|imbolc|ostara|beltane|litha|lughnasadh|lammas|mabon|samhain|pagan.festival|sacred.calendar|solstice|equinox/],
    ['astrology_lunar', /astrology|zodiac|birth.chart|horoscope|planetary|moon.phase|lunar/],
    ['rituals_witchcraft', /ritual|witchcraft|spell|altar|pentagram|pentacle|magic|magick|protection/],
    ['deities', /gods|goddesses|deity|lilith|morrigan|brigid|persephone|aphrodite|anubis/]
  ];
  const topic = (topicRules.find((rule) => rule[1].test(topicSource)) || ['general'])[0];
  const sent = new Set();
  let activeMilliseconds = 0;
  let lastTick = Date.now();
  let maximumDepth = 0;
  let readinessTimer;
  let attempts = 0;
  let engagementTimer;

  const analyticsAllowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  };

  const ready = () => analyticsAllowed() && typeof window.gtag === 'function';

  const send = (eventName, details = {}, once = true) => {
    if (!ready() || (once && sent.has(eventName))) return false;
    window.gtag('event', eventName, {
      send_to: context.measurementId,
      blog_topic: topic,
      article_handle: context.articleHandle,
      blog_handle: context.blogHandle,
      article_title: context.articleTitle,
      tracking_version: '2026_10_20',
      ...details
    });
    if (once) sent.add(eventName);
    return true;
  };

  const ensureArticleView = () => {
    if (!ready()) return false;
    send('blog_article_view');
    if (topic === 'hecate') send('hecate_view', { content_type: 'article' });
    return sent.has('blog_article_view');
  };

  const articleContent = document.querySelector('.article__content .rte') || document.querySelector('.article__content');
  const contentVisible = () => {
    if (!articleContent || document.visibilityState !== 'visible') return false;
    const rect = articleContent.getBoundingClientRect();
    if (rect.top >= window.innerHeight || rect.bottom <= 0) return false;
    const x = Math.max(0, Math.min(window.innerWidth - 1, (rect.left + rect.right) / 2));
    const y = (Math.max(0, rect.top) + Math.min(window.innerHeight, rect.bottom)) / 2;
    return articleContent.contains(document.elementFromPoint(x, y));
  };
  const updateDepth = () => {
    if (!analyticsAllowed() || !contentVisible()) return;
    const rect = articleContent.getBoundingClientRect();
    if (rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0) {
      maximumDepth = Math.max(maximumDepth, Math.min(1, (window.innerHeight - rect.top) / rect.height));
    }
  };

  const tick = () => {
    const now = Date.now();
    const elapsed = Math.min(now - lastTick, 2000);
    lastTick = now;
    if (!analyticsAllowed() || document.visibilityState !== 'visible') return;
    if (contentVisible() && sent.has('blog_article_view')) {
      activeMilliseconds += elapsed;
    }
    updateDepth();
    if (activeMilliseconds < 30000 || maximumDepth < 0.5 || !ensureArticleView()) return;
    const details = { engagement_method: '30_visible_seconds_and_50_percent_article', reading_time_seconds: Math.floor(activeMilliseconds / 1000) };
    if (send('blog_engaged_reader', details)) {
      if (topic === 'hecate') send('hecate_engaged_reader', details);
      window.clearInterval(engagementTimer);
    }
  };

  const checkReadiness = () => {
    attempts += 1;
    if (ensureArticleView() || attempts >= 240) {
      window.clearInterval(readinessTimer);
      readinessTimer = undefined;
    }
  };

  const restartReadiness = () => {
    lastTick = Date.now();
    if (ensureArticleView() || readinessTimer) return;
    attempts = 0;
    readinessTimer = window.setInterval(checkReadiness, 500);
  };

  document.addEventListener('visitorConsentCollected', restartReadiness);
  document.addEventListener('visibilitychange', () => { lastTick = Date.now(); });
  window.addEventListener('scroll', updateDepth, { passive: true });

  document.addEventListener('click', (event) => {
    const link = event.target?.closest?.('a[href]');
    if (!link || !analyticsAllowed()) return;
    let target;
    try {
      target = new URL(link.href, window.location.origin);
    } catch (_) {
      return;
    }
    if (target.origin !== window.location.origin) return;
    const targetType = /\/products\/[^/]+/.test(target.pathname) ? 'product' : /\/collections\/[^/]+/.test(target.pathname) ? 'collection' : null;
    if (!targetType || !ensureArticleView()) return;
    send(targetType === 'product' ? 'blog_product_click' : 'blog_collection_click', {
      target_type: targetType,
      target_url: target.pathname,
      transport_type: 'beacon'
    }, false);
  }, { capture: true });

  engagementTimer = window.setInterval(tick, 1000);
  restartReadiness();
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
      if (!error) restartReadiness();
    });
  }
})();
